import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

export default function IngredientEntry({ ingredient, onRemove }) {
  return (
    <div className="clearfix foodItem">
      <div className="foodItem-content">
        <div className="foodItem-name">
          <a
            target="_blank"
            href={`/ingredients/fcdb/${ingredient.idIngredient}`}
            rel="noreferrer">
            {ingredient.name}
          </a>
        </div>
        <a className="btn foodItem-delete" onClick={() => onRemove(ingredient)}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </a>
      </div>
    </div>
  )
}
